<template>
  <div :class="$style.container">
    <Form :project="project" readonly />
  </div>
</template>

<script>
import Form from "./Form.vue";
export default {
  components: {
    Form,
  },
  props: {
    project: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" module>
.container {
  background-color: $bg-primary;
  padding: 1.5rem;
  .files {
    display: flex;
    align-items: center;
    gap: 1rem;
  }
}
</style>
